import { Component } from '@angular/core';
import { NgOptimizedImage } from "@angular/common";
import { isEvaranBranding } from '@shared/config';

@Component({
    selector: 'app-auth-logo',
    templateUrl: './auth-logo.component.html',
    styleUrls: ['./auth-logo.component.scss'],
    standalone: true,
    imports: [NgOptimizedImage]
})
export class AuthLogoComponent {
    protected readonly logoSrc = isEvaranBranding() ? '/img/full.logo.evaran.svg' : '/img/full.logo.svg';
    protected readonly logoAlt = isEvaranBranding() ? 'Evaran' : 'CareLineLive';
}
